import { Component, OnInit, OnDestroy } from '@angular/core';
import { Router, ActivatedRoute } from "@angular/router";
import { HttpResponse } from '@angular/common/http';

import { TitleService } from '@core/services/title.service';

import * as Objects from '@core/objects';

import { ApolloRequests } from '@plugins/apollo/src/App/services/apollo/apollo-requests.service';
class SelectedFilesToCompare {
    public target: Objects.AmsFile = null;
    public reference: Objects.AmsFile = null;
    //protected groups: Array<SelectedFilesToCompareGroupFiles> = [];
    public selected: Array<Objects.AmsFile> = [];
    public completed: boolean = false; 

    isComplete(): boolean {
        //return this.reference!= null && this.target != null;
        return this.selected.length == 2;
    }

    changeOrder() {
        let tmp = this.target;
        this.target = this.reference;
        this.reference = tmp;
    }

    setSelected(files: Array<Objects.AmsFile>) {
        this.selected = files;

        this.applyChanges();
    }

    applyChanges() {
        //return from(this.selected)
        this.removeIfNotExist('reference');
        this.removeIfNotExist('target');

        this.setIfExist('reference');
        this.setIfExist('target');

        this.completed = this.isComplete();
    }

    remove(type: string) {
        let file = this.get(type);
        let files = this.selected.filter(f => f.id != file.id);
        this.setSelected(files);
    }

    protected has(type: string): boolean {
        return this[type] != null;
    }

    protected get(type: string): Objects.AmsFile | null {
        return this[type];
    }

    protected removeIfNotExist(type: string ) {
        if(this.has(type)) {
            let file = this.get(type);
            let files = this.selected.filter(f => f.id == file.id);
            if(files.length == 0)
                this[type] = null;
        }
    }

    protected setIfExist(type: string) {
        let opposite = type == 'reference'? 'target' : 'reference';
        if(!this.has(type)) {
            let files = [...this.selected];
            if(this.has(opposite)) {
                let remove = this.get(opposite);
                files = files.filter(f => f.id != remove.id);
            }

            if(files.length > 0)
                this[type] = files[0];

        }
    }

}

@Component({
    selector: 'plugin-apollo-main-section-request',
    templateUrl: './request.component.html',
    styleUrls: ['./request.component.scss']
})
export class PluginApolloMainSectionRequestComponent implements OnInit, OnDestroy {

    public readonly LOADING = 0;
    public readonly DONE = 1;
    public readonly NOT_FOUND = 3;

    readonly uploadUrl: string = "/p/apollo/upload/";

    public reference: Objects.AmsFile = null;
    public target: Objects.AmsFile = null;

    public status:number = this.LOADING;
    public project: Objects.Request = null;
    public partialProject: Objects.BasicRequest = null;
    public filesUrl: string = "";

    public files: SelectedFilesToCompare = new SelectedFilesToCompare();

    public breadcrumbText: string = 'SELECT FILES TO COMPARE';
    public breadcrumbs: any = [
        {
            title: "",
            link: ['']
        }
    ];

    constructor(public apolloReqSrv: ApolloRequests, private router: Router, private activeRoute: ActivatedRoute, private title: TitleService){}

    ngOnInit() {
        let projectId = this.activeRoute.snapshot.paramMap.get('id');

        this.title.set("Select files to compare from Project #" +projectId+" - XRay");
        this.filesUrl = "/projects/" + projectId +"/attachments";
        this.loadRequest(Number(projectId));

    }

    onChange(e) {
        if(e.length<3)
            this.files.setSelected(e);
    }

    ngOnDestroy(){

    }

    cancel() {
        this.files.remove('reference');
        this.files.remove('target');
    }

    goToCompare() {
        if(!this.files.isComplete())
            return;
        // router to upload
        let query = {
            reference: this.files.reference.id,
            target: this.files.target.id
        };

        this.router.navigate([this.uploadUrl], { queryParams: query});

    }


    protected loadRequest(projectId: number){
        this.apolloReqSrv.loadProject(projectId).subscribe({
                    next: (response: HttpResponse<Objects.Request>) => {
                        if (response.status === 200) {
                            // Full success
                            this.project = response.body as Objects.Request;
                        } else if (response.status === 206) {
                            // Partial content: User has limited access, set project partial instead
                            this.partialProject = response.body as Objects.BasicRequest;
                        }
                        this.updateBreadcrumbs(response.body as Objects.Request);
                        this.status = this.DONE;
                    },
                    error: (error:any) => {
                        this.status = this.NOT_FOUND;
                    }
                });
    }

    selectFiles(files: Array<Objects.AmsFile>){
    }

    protected updateBreadcrumbs(project: Objects.Request) {
        this.breadcrumbs[0].link = '/projects/' + project.id;
        this.breadcrumbs[0].title = 'Project <small>(#' + project.id + ')</small>';
    }
}
